export default __webpack_public_path__ + "static/media/nerofit-image.201704aa.jpg";